import { Container, Row, Col, Button, Card, Accordion } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import NewHeader from "../_components/_global/WelcomeHeader";

// --- City data: CA / NA / International ---
const cities = [
  {
    name: "Toronto",
    country: "Canada",
    rating: 4.9,
    days: "3-5 days",
    activities: "28 activities",
    image:
      "https://images.unsplash.com/photo-1517090504586-fde19ea6066f?w=800&q=80",
  },
  {
    name: "Vancouver",
    country: "Canada",
    rating: 4.8,
    days: "4-6 days",
    activities: "32 activities",
    image:
      "https://images.unsplash.com/photo-1559511260-66a654ae982a?w=800&q=80",
  },
  {
    name: "Montreal",
    country: "Canada",
    rating: 4.7,
    days: "3-5 days",
    activities: "26 activities",
    image:
      "https://images.unsplash.com/photo-1519178614-68673b201f36?w=800&q=80",
  },
  {
    name: "New York",
    country: "USA",
    rating: 4.9,
    days: "3-5 days",
    activities: "30 activities",
    image:
      "https://images.unsplash.com/photo-1546436836-07a91091f160?w=800&q=80",
  },
];

// --- Feature data (4 cards) ---
const features = [
  {
    icon: "bi-stars",
    title: "AI-Powered Planning",
    desc: "Personalized itineraries built around your interests and travel style.",
  },
  {
    icon: "bi-send",
    title: "Real-time Navigation",
    desc: "Integrated maps and guidance for seamless city exploration.",
  },
  {
    icon: "bi-people",
    title: "Travel Community",
    desc: "Share tips and discover curated local favorites from others.",
  },
  {
    icon: "bi-globe2",
    title: "Multi-city Support",
    desc: "From Canada to the world—add or switch cities with one click.",
  },
];

export default function WelcomepageDesktop() {
  const navigate = useNavigate();
  const location = useLocation();
  const handleGetStarted = () => navigate("/city-selection");
  const handleWatchDemo = () => navigate("/watch-demo");
  const [scrolled, setScrolled] = useState(false);
  const [yearlyBilling, setYearlyBilling] = useState(false);

  useEffect(() => {
    // 使用 window.location 而不是 useLocation
    if (window.location.hash) {
      const id = window.location.hash.substring(1);
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
    }
  }, []); // 空依赖数组，只在组件挂载时运行

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <NewHeader scrolled={scrolled} />
      {/* scoped styles for this hero page */}
      <style>{`

      .page-wrapper {
          padding-top: 72px; /* 为固定的header留出空间 */
        }
        .hero-wrap{padding:64px 0 32px;}
        .eyebrow{display:inline-flex;gap:8px;align-items:center;background:#eef5ff;border:1px solid #dae7ff;color:#2a61ff;border-radius:999px;padding:6px 12px;font-weight:600;font-size:12px;}
        .hero-title{font-size:56px;line-height:1.05;font-weight:800;color:#0f1720;margin:18px 0;}
        .hero-desc{font-size:18px;color:#495a6b;max-width:680px}
        .cta-row{display:flex;gap:14px;margin-top:22px}
        .cta-primary{background:#1b2a41;border:none;padding:12px 18px;border-radius:12px;color:#fff;font-weight:700;transition:all 0.3s;}
        .cta-primary:hover{background:#2a3a51;transform:translateY(-2px);}
        .cta-ghost{background:#fff;border:1px solid #e6eaf0;padding:12px 18px;border-radius:12px;color:#0f1720;font-weight:700}
        .stats{display:flex;gap:36px;border-top:1px solid #e9eef3;padding-top:24px;margin-top:28px}
        .stat b{display:block;font-size:20px;color:#0f1720}
        .stat span{font-size:13px;color:#6a7a8a}

         .city-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    position: relative;
  }
  
  .city-card {
    position: relative;
    border-radius: 20px;
    overflow: hidden;
    height: 240px;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    box-shadow: 0 5px 20px rgba(0,0,0,0.08);
  }
  
  .city-card:hover {
    transform: translateY(-8px) scale(1.02);
    box-shadow: 0 15px 40px rgba(0,0,0,0.15);
  }
  
  /* 交错排列效果 */
  .city-card:nth-child(even) {
    margin-top: 30px;
  }
  
  .city-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
  }
  
  .city-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, 
      rgba(0,0,0,0) 0%, 
      rgba(0,0,0,0.1) 50%, 
      rgba(0,0,0,0.4) 100%);
  }
  
  .city-rating {
    position: absolute;
    top: 12px;
    right: 12px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    padding: 4px 10px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    font-weight: 600;
  }
  
  .city-rating i {
    color: #FFB800;
    font-size: 12px;
  }
  
  .city-content {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 20px;
    color: white;
    z-index: 1;
  }
  
  .city-name {
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 4px;
  }
  
  .city-country {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    opacity: 0.9;
    margin-bottom: 12px;
  }
  
  .city-country i {
    font-size: 12px;
  }
  
  .city-meta {
    display: flex;
    gap: 16px;
    font-size: 13px;
    opacity: 0.95;
  }
  
  .city-meta-item {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  
  .city-meta-item i {
    font-size: 12px;
    opacity: 0.8;
  }

        .smart-card{position:absolute;right:-14px;bottom:-12px;width:320px;background:#fff;border-radius:16px;border:1px solid #e8edf2;box-shadow:0 10px 30px rgba(0,0,0,.06);padding:16px;animation:float 3s ease-in-out infinite;}
        @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-10px)}}
        .smart-card h6{margin:0 0 2px;font-size:16px;color:#0f1720}
        .smart-card small{color:#6a7a8a}
        .smart-item{display:flex;align-items:center;gap:8px;margin-top:8px;color:#19442b;font-size:13px}
        .smart-item i{color:#18a556}

        .feature-wrap{padding:56px 0}
        .feature-title{text-align:center;margin-bottom:10px;font-weight:800;color:#0f1720}
        .feature-sub{text-align:center;color:#5b6b7a;margin-bottom:32px}
        .f-card{border:1px solid #e8edf2;border-radius:16px;padding:18px;background:#fff;height:100%;transition:all 0.3s;}
        .f-card:hover{transform:translateY(-4px);box-shadow:0 8px 20px rgba(0,0,0,.08);}
        .f-icon{width:40px;height:40px;border-radius:10px;background:#f3f6ff;display:flex;align-items:center;justify-content:center;color:#2a61ff;font-size:18px;margin-bottom:10px}
        .f-card h5{font-size:16px;margin:0 0 6px}
        .f-card p{margin:0;color:#5b6b7a;font-size:13px}


          /* How it works */
  .how-it-works-section {
    padding: 80px 0;
    background: #f9fafb;
  }
  
  .section-title-main {
    font-size: 42px;
    font-weight: 800;
    text-align: center;
    color: #0f1720;
    margin-bottom: 12px;
  }
  
  .section-subtitle {
    text-align: center;
    color: #6a7a8a;
    font-size: 18px;
    margin-bottom: 48px;
  }
  
  .step-card {
    text-align: center;
    padding: 32px;
  }
  
  .step-number {
    width: 48px;
    height: 48px;
     background: #1b2a41;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 700;
    margin: 0 auto 24px;
  }

  .step-number:hover {
    background: #2a3a51;  /* 悬停时稍微亮一点 */
    transform: scale(1.05);
  }
  
  .step-card h4 {
    font-size: 20px;
    margin-bottom: 12px;
    color: #0f1720;
  }
  
  .step-card p {
    color: #6a7a8a;
    line-height: 1.6;
  }
  
  /* Destinations */
  .destinations-section {
    padding: 80px 0;
  }
  
  .destination-card {
    position: relative;
    border-radius: 16px;
    overflow: hidden;
    height: 280px;
    cursor: pointer;
    transition: all 0.3s;
  }
  
  .destination-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 40px rgba(0,0,0,0.15);
  }
  
  .destination-card img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .destination-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 24px;
    background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
    color: white;
  }
  
  .destination-overlay h4 {
    font-size: 24px;
    margin-bottom: 4px;
  }
  
  .destination-tags {
    position: absolute;
    bottom: 16px;
    left: 24px;
    display: flex;
    gap: 8px;
  }
  
  .tag {
    background: rgba(255,255,255,0.2);
    backdrop-filter: blur(10px);
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 12px;
    color: white;
  }
  
  /* Testimonials */
  .testimonials-section {
    padding: 80px 0;
    background: #f9fafb;
  }
  
  .testimonial-card {
    background: white;
    padding: 32px;
    border-radius: 16px;
    height: 100%;
  }
  
  .stars {
    color: #FFB800;
    font-size: 18px;
    margin-bottom: 16px;
  }
  
  .testimonial-text {
    color: #495a6b;
    line-height: 1.6;
    margin-bottom: 24px;
  }
  
  .testimonial-author strong {
    display: block;
    color: #0f1720;
    margin-bottom: 4px;
  }
  
  .testimonial-author span {
    color: #6a7a8a;
    font-size: 14px;
  }
  
  /* Pricing */
  .pricing-section {
    padding: 80px 0;
  }
  
  .pricing-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin: 32px 0;
  }
  
  .pricing-card {
    background: white;
    border: 2px solid #e8edf2;
    border-radius: 20px;
    padding: 40px;
    text-align: center;
  }
  
  .pricing-card.featured {
    border-color: #2a61ff;
    transform: scale(1.05);
  }
  
  .price .amount {
    font-size: 48px;
    font-weight: 700;
    color: #0f1720;
  }
  
  .price .period {
    color: #6a7a8a;
  }


 .toggle-badge {
    background: #10b981;
    color: white;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    margin-left: 4px;
  }
    
  /* iOS 风格切换开关 */
  .toggle-switch {
    position: relative;
    display: inline-block;
    width: 51px;
    height: 31px;
  }
  
  .toggle-switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  .toggle-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #e5e7eb;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border-radius: 31px;
  }
  
  .toggle-slider:before {
    position: absolute;
    content: "";
    height: 27px;
    width: 27px;
    left: 2px;
    bottom: 2px;
    background: white;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
  
  input:checked + .toggle-slider {
    background: #1b2a41;
  }
  
  input:checked + .toggle-slider:before {
    transform: translateX(20px);
  }
  
  /* 添加悬停效果 */
  .toggle-switch:hover .toggle-slider {
    box-shadow: 0 0 0 2px rgba(27, 42, 65, 0.1);
  }
  
  input:checked + .toggle-slider:hover {
    background: #2a3a51;
  }
  
  .features-list {
    list-style: none;
    padding: 0;
    text-align: left;
  }
  
  .features-list li {
    padding: 8px 0;
    color: #495a6b;
  }
  
   /* FAQ Section */
  .faq-section {
    padding: 80px 0;
    background: #f9fafb;
  }
  
  .faq-accordion {
    max-width: 800px;
    margin: 48px auto 0;
  }
  
  .faq-accordion .accordion-item {
    background: transparent;
    border: none;
    border-bottom: 1px solid #e8edf2;
    margin-bottom: 0;
  }
  
  .faq-accordion .accordion-item:last-child {
    border-bottom: none;
  }
  
  .faq-accordion .accordion-header .accordion-button {
    background: transparent;
    border: none;
    padding: 24px 0;
    font-size: 16px;
    font-weight: 500;
    color: #0f1720;
    box-shadow: none;
  }
  
  .faq-accordion .accordion-button:not(.collapsed) {
    background: transparent;
    color: #0f1720;
    box-shadow: none;
  }
  
  .faq-accordion .accordion-button::after {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23495a6b'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  }
  
  .faq-accordion .accordion-button:not(.collapsed)::after {
    transform: rotate(-180deg);
  }
  
  .faq-accordion .accordion-body {
    padding: 0 0 24px 0;
    color: #6a7a8a;
    line-height: 1.6;
    font-size: 15px;
  }
  }
      `}</style>

      <Container className="hero-wrap">
        <Row className="align-items-start g-4">
          {/* LEFT: Hero */}
          <Col lg={7}>
            <div className="eyebrow">
              <i className="bi bi-magic"></i> AI-Powered Travel Assistant
            </div>
            <h1 className="hero-title">
              Plan, book, and explore with your FIT guide — anytime, anywhere.
            </h1>
            <p className="hero-desc">
              Experience intelligent trip planning with our AI assistant. Get
              personalized itineraries, real-time navigation, and connect with
              fellow travelers across North America and beyond.
            </p>

            <div className="cta-row">
              <Button className="cta-primary" onClick={handleGetStarted}>
                Start My Journey <i className="bi bi-arrow-right ms-1"></i>
              </Button>
              <Button
                variant="light"
                className="cta-ghost"
                onClick={handleWatchDemo}
              >
                <i className="bi bi-play-fill me-1"></i> Watch Demo
              </Button>
            </div>

            {/* Stats */}
            <div className="stats">
              <div className="stat">
                <b>50K+</b>
                <span>Happy Travelers</span>
              </div>
              <div className="stat">
                <b>1M+</b>
                <span>Places Discovered</span>
              </div>
              <div className="stat">
                <b>100K+</b>
                <span>Trip Plans Created</span>
              </div>
              <div className="stat">
                <b>4.9★</b>
                <span>User Rating</span>
              </div>
            </div>
          </Col>

          {/* RIGHT: City grid + smart planning floating card */}
          <Col lg={5} className="position-relative">
            <div className="city-grid">
              {cities.map((city) => (
                <div
                  key={city.name}
                  className="city-card"
                  onClick={handleGetStarted}
                >
                  <img
                    src={city.image}
                    alt={city.name}
                    className="city-image"
                  />
                  <div className="city-overlay"></div>

                  <div className="city-rating">
                    <i className="bi bi-star-fill"></i>
                    <span>{city.rating}</span>
                  </div>

                  <div className="city-content">
                    <h3 className="city-name">{city.name}</h3>
                    <div className="city-country">
                      <i className="bi bi-geo-alt"></i>
                      {city.country}
                    </div>
                    <div className="city-meta">
                      <div className="city-meta-item">
                        <i className="bi bi-calendar3"></i>
                        <span>{city.days}</span>
                      </div>
                      <div className="city-meta-item">
                        <i
                          className="bi bi-circle-fill"
                          style={{ fontSize: "4px" }}
                        ></i>
                        <span>{city.activities}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* floating smart planning card */}
            <div className="smart-card d-none d-lg-block">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  marginBottom: 6,
                }}
              >
                <i
                  className="bi bi-check2-circle"
                  style={{ color: "#18a556", fontSize: 22 }}
                ></i>
                <div>
                  <h6>Smart Planning</h6>
                  <small>AI-generated itinerary</small>
                </div>
              </div>
              <div className="smart-item">
                <i className="bi bi-check-circle-fill"></i> 3-day Toronto trip
              </div>
              <div className="smart-item">
                <i className="bi bi-check-circle-fill"></i> 12 destinations
              </div>
              <div className="smart-item">
                <i className="bi bi-check-circle-fill"></i> Budget friendly
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Features block */}
      <Container id="features" className="feature-wrap">
        <div className="text-center">
          <span
            className="eyebrow"
            style={{
              background: "#f4f7fb",
              borderColor: "#e7edf5",
              color: "#687a8f",
            }}
          >
            Why choose CityGetAway
          </span>
        </div>
        <h2 className="feature-title mt-3">
          Everything you need for the perfect city adventure
        </h2>
        <p className="feature-sub">
          From AI-powered planning to real-time navigation, we cover every
          aspect of your urban journey.
        </p>

        <Row className="g-3">
          {features.map((f) => (
            <Col md={6} key={f.title}>
              <div className="f-card">
                <div className="f-icon">
                  <i className={`bi ${f.icon}`} />
                </div>
                <h5>{f.title}</h5>
                <p>{f.desc}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      <div className="how-it-works-section">
        <Container>
          <h2 className="section-title-main">How it works</h2>
          <p className="section-subtitle">
            Start your adventure in three simple steps
          </p>

          <Row className="g-4 mt-4">
            <Col md={4}>
              <div className="step-card">
                <div className="step-number">1</div>
                <h4>Choose Your City</h4>
                <p>
                  Select from hundreds of cities worldwide. Browse destinations
                  or let our AI recommend the perfect spot based on your
                  preferences.
                </p>
              </div>
            </Col>
            <Col md={4}>
              <div className="step-card">
                <div className="step-number">2</div>
                <h4>Personalize Your Trip</h4>
                <p>
                  Tell us about your interests, budget, and travel style. Our AI
                  creates a custom itinerary just for you in seconds.
                </p>
              </div>
            </Col>
            <Col md={4}>
              <div className="step-card">
                <div className="step-number">3</div>
                <h4>Get Live Guidance</h4>
                <p>
                  Follow your personalized itinerary with real-time navigation
                  and recommendations. Adjust on the fly as you explore.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Popular destinations 部分 */}
      <div className="destinations-section">
        <Container>
          <h2 className="section-title-main">Explore popular destinations</h2>
          <p className="section-subtitle">
            Discover cities loved by travelers worldwide
          </p>

          <Row className="g-4 mt-4">
            {[
              {
                name: "Tokyo",
                country: "Japan",
                tags: ["Family", "Food", "Culture"],
                image:
                  "https://images.unsplash.com/photo-1503899036084-c55cdd92da26?w=800",
              },
              {
                name: "Paris",
                country: "France",
                tags: ["Romantic", "Art", "Food"],
                image:
                  "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=800",
              },
              {
                name: "Barcelona",
                country: "Spain",
                tags: ["Beach", "Architecture", "Budget friendly"],
                image:
                  "https://images.unsplash.com/photo-1583422409516-2895a77efded?w=800",
              },
              {
                name: "Rome",
                country: "Italy",
                tags: ["History", "Food", "Culture"],
                image:
                  "https://images.unsplash.com/photo-1552832230-c0197dd311b5?w=800",
              },
            ].map((city) => (
              <Col lg={3} md={6} key={city.name}>
                <div className="destination-card" onClick={handleGetStarted}>
                  <img src={city.image} alt={city.name} />
                  <div className="destination-overlay">
                    <h4>{city.name}</h4>
                    <p>{city.country}</p>
                  </div>
                  <div className="destination-tags">
                    {city.tags.map((tag) => (
                      <span key={tag} className="tag">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>

      {/* Testimonials 部分 */}
      <div className="testimonials-section">
        <Container>
          <h2 className="section-title-main">Loved by travelers worldwide</h2>
          <p className="section-subtitle">See what our community has to say</p>

          <Row className="g-4 mt-5">
            {[
              {
                stars: 5,
                text: "CityGetAway transformed how I explore new cities. The AI-powered itineraries are spot-on and saved me hours of planning!",
                author: "Sarah Johnson",
                location: "San Francisco, CA",
              },
              {
                stars: 5,
                text: "I've used many travel apps, but this one stands out. The personalized recommendations helped me discover hidden gems I'd never find on my own.",
                author: "Michael Chen",
                location: "Toronto, ON",
              },
              {
                stars: 5,
                text: "The real-time navigation feature is a game-changer. Never got lost once during my trip to Barcelona. Highly recommended!",
                author: "Emma Williams",
                location: "London, UK",
              },
            ].map((testimonial, idx) => (
              <Col md={4} key={idx}>
                <div className="testimonial-card">
                  <div className="stars">{"★".repeat(testimonial.stars)}</div>
                  <p className="testimonial-text">"{testimonial.text}"</p>
                  <div className="testimonial-author">
                    <strong>{testimonial.author}</strong>
                    <span>{testimonial.location}</span>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>

      {/* Pricing 部分 */}
      <div className="pricing-section">
        <Container>
          <h2 className="section-title-main">Simple, transparent pricing</h2>
          <p className="section-subtitle">
            Choose the plan that's right for you
          </p>

          <div className="pricing-toggle">
            <span
              className={
                !yearlyBilling ? "toggle-label active" : "toggle-label"
              }
            >
              Monthly
            </span>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={yearlyBilling}
                onChange={() => setYearlyBilling(!yearlyBilling)}
              />
              <span className="toggle-slider"></span>
            </label>
            <span
              className={yearlyBilling ? "toggle-label active" : "toggle-label"}
            >
              Yearly
              <span className="toggle-badge">Save 20%</span>
            </span>
          </div>

          <Row className="g-4 mt-4 justify-content-center">
            <Col md={5}>
              <div className="pricing-card">
                <h3>Free</h3>
                <div className="price">
                  <span className="amount">$0</span>
                  <span className="period">/ forever</span>
                </div>
                <Button variant="outline-dark" className="w-100 mb-4">
                  Start Free
                </Button>
                <ul className="features-list">
                  <li>✓ Basic city planning tools</li>
                  <li>✓ Access to public itineraries</li>
                  <li>✓ Community travel tips</li>
                  <li>✓ Up to 3 saved trips</li>
                  <li>✓ Standard support</li>
                </ul>
              </div>
            </Col>
            <Col md={5}>
              <div className="pricing-card featured">
                <h3>Pro</h3>
                <div className="price">
                  <span className="amount">${yearlyBilling ? "8" : "10"}</span>
                  <span className="period">/ month</span>
                </div>
                <Button variant="dark" className="w-100 mb-4">
                  Start Pro Trial
                </Button>
                <ul className="features-list">
                  <li>✓ Advanced AI itinerary builder</li>
                  <li>✓ Unlimited saved trips</li>
                  <li>✓ Offline access & maps</li>
                  <li>✓ Priority support</li>
                  <li>✓ Multi-city trip planning</li>
                  <li>✓ Real-time collaboration</li>
                  <li>✓ Exclusive local deals</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* FAQ 部分 */}
      <div className="faq-section">
        <Container>
          <h2 className="section-title-main">Frequently asked questions</h2>
          <p className="section-subtitle">
            Everything you need to know about CityGetAway
          </p>
          <div className="faq-container">
            <Accordion className="faq-accordion" flush>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  How does CityGetAway protect my data and privacy?
                </Accordion.Header>
                <Accordion.Body>
                  We take your privacy seriously. All your data is encrypted
                  end-to-end, and we never share your personal information with
                  third parties. You have full control over your data and can
                  delete your account anytime.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1">
                <Accordion.Header>What's your refund policy?</Accordion.Header>
                <Accordion.Body>
                  We offer a 30-day money-back guarantee for Pro subscriptions.
                  If you're not satisfied, contact our support team for a full
                  refund within 30 days of purchase.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  How many cities are supported?
                </Accordion.Header>
                <Accordion.Body>
                  CityGetAway supports over 500 cities across 100+ countries.
                  We're constantly adding new destinations based on user
                  requests. Check our website for the full list of supported
                  cities.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  Can I use CityGetAway offline?
                </Accordion.Header>
                <Accordion.Body>
                  Yes! Pro users can download city guides and maps for offline
                  access. Perfect for when you're traveling without reliable
                  internet connection.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="4">
                <Accordion.Header>
                  Is CityGetAway available in multiple languages?
                </Accordion.Header>
                <Accordion.Body>
                  Yes, we support 15+ languages including English, Spanish,
                  French, German, Japanese, and more. The app automatically
                  detects your device language or you can manually select your
                  preference.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="5">
                <Accordion.Header>
                  Can I share my itinerary with travel companions?
                </Accordion.Header>
                <Accordion.Body>
                  Absolutely! Pro users can share and collaborate on itineraries
                  in real-time. Everyone in your group can add suggestions, vote
                  on activities, and stay synchronized throughout your trip.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="6">
                <Accordion.Header>
                  How accurate are the AI recommendations?
                </Accordion.Header>
                <Accordion.Body>
                  Our AI is trained on millions of travel experiences and
                  continuously learns from user feedback. We maintain a 4.9/5
                  satisfaction rating, with most users rating our
                  recommendations as highly accurate and personalized.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="7">
                <Accordion.Header>
                  Do you offer discounts for students or groups?
                </Accordion.Header>
                <Accordion.Body>
                  Yes! We offer 50% off Pro subscriptions for students with
                  valid student ID. Group plans (5+ travelers) also qualify for
                  special discounts. Contact our sales team for more
                  information.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </Container>
      </div>
    </>
  );
}
